export default __webpack_public_path__ + "assets/langSwitcher2.png";